<template>
  <div class="info">
    <!-- <div class="card ctop">
      <div class="title">泳池密度</div>
      <div class="midu">
        <div class="left">
          <div class="circle">
            <div class="con">
              <div class="num fx-led"><span>10.2</span>%</div>
              <div class="desc">当前泳池密度</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="item low">低密度(&lt;60人)</div>
          <div class="item middle">中密度(60-130人)</div>
          <div class="item high">高密度(&gt;130)</div>
        </div>
      </div>
    </div> -->
    <div class="card cmiddle">
      <div class="title">三类从业人员信息</div>
      <div class="people-info">
        <div class="item" v-for="(item, i) in three_kind" :key="i">
          <div class="p-title">{{ item.title }}</div>
          <div class="p-item">
            <div class="name">姓名</div>
            <div class="val">{{ item.name }}</div>
          </div>
          <div class="p-item">
            <div class="name">手机号</div>
            <div class="val">{{ item.mobile }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card cbottom">
      <div class="title">场馆在册救生员</div>
      <div class="table">
        <div class="thead">
          <div class="h-item">姓名</div>
          <div class="h-item">性别</div>
          <div class="h-item">岗位名称</div>
        </div>
        <div class="tbody">
          <div class="t-item" v-for="(item, index) in list" :key="index">
            <div class="b-item">{{ item.name }}</div>
            <div class="b-item">{{ item.gender == 1 ? '男' : '女' }}</div>
            <div class="b-item">{{ item.role == 2 ? '救生员' : '救生组长' }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <a-row class="person-info" :gutter="32">
      <a-col span="12" v-for="(item, index) in list" :key="index">
        <div class="item">
          <div class="avatar">
            <img src="../../assets/dongti/person.png" />
          </div>
          <div class="i-item">
            <span>姓名</span>
            <span class="val">{{ item.name }}</span>
          </div>
          <div class="i-item">
            <span>岗位</span>
            <span class="val">{{ item.label }}</span>
          </div>
        </div>
      </a-col>
    </a-row> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      list: [],
      three_kind: [],
    }
  },
  computed: {
    ...mapState({
      sid: (state) => state.user.sid,
    }),
  },
  mounted() {
    this.get_guard()
    this.get_three_kind()
  },
  methods: {
    get_three_kind() {
      this.$http({
        url: 'api/three-kind',
        method: 'get',
        data: {
          sid: this.sid,
        },
      }).then((r) => {
        this.three_kind = r.data
      })
    },
    get_guard() {
      this.$http({
        url: 'api/guards',
        method: 'get',
        data: {
          sid: this.sid,
        },
      }).then((r) => {
        this.list = r.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.card {
  background: #082d58;
  box-shadow: 0px 4px 12px 0px rgba(0, 33, 70, 1);
  border-radius: 6px;
  padding: 0 30px;
  & + .card {
    margin-top: 14px;
  }
  &.ctop {
    height: 227px;
  }
  &.cmiddle {
    height: 318px;
  }
  &.cbottom {
    height: 609px;
  }
}
.info {
  color: #fff;
  height: 100%;
  .title {
    font-size: 18px;
    color: #32c5ff;
    padding: 12px 24px;
    margin-left: -16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .midu {
    color: #fff;
    display: flex;
    padding: 0px 20px;
    .left {
      .circle {
        width: 161px;
        height: 161px;
        border-radius: 50%;
        border: 6px solid #07b4e1;
        padding: 8px;
        .con {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: #07b4e1;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .num {
            font-size: 32px;
            span {
              font-size: 48px;
            }
          }
          .desc {
            font-size: 14px;
          }
        }
      }
    }
    .right {
      padding-top: 30px;
      padding-left: 24px;
      .item {
        font-size: 12px;
        padding: 5px 0;
        display: flex;
        align-items: center;
        &::before {
          content: ' ';
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 8px;
        }
        &.low::before {
          background: #07b4e1;
        }
        &.middle::before {
          background: #fcb002;
        }
        &.high::before {
          background: #f83d2d;
        }
      }
    }
  }
  .people-info {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px;
    .item {
      width: 50%;
      padding: 0 8px;
      .p-title {
        font-size: 18px;
        font-weight: 500;
        padding: 12px 0 0px;
      }
      .p-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #beecff;
        padding: 8px 0;
        border-bottom: 1px solid #79d9ff;
        .val {
          color: #00cbff;
        }
      }
    }
  }
  .table {
    .h-item,
    .b-item {
      width: 33.333333%;
      text-align: center;
    }
    .thead {
      display: flex;
      align-items: center;
      font-size: 18px;
      background: #30bff9;
      border-radius: 4px;
      padding: 10px 0;
      color: #fff;
    }
    .tbody {
      height: 485px;
      overflow: auto;
      .t-item {
        display: flex;
        align-items: center;
        font-size: 12px;
        padding: 10px;
        border-bottom: 1px solid #03577e;
        &:nth-of-type(even) {
          background: #244a75;
        }
      }
    }
  }
  .person-info {
    height: 42%;
    overflow: auto;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 6px;
      border-bottom: 1px solid #79d9ff;
      margin-bottom: 20px;
      .avatar {
        margin-bottom: 10px;
        img {
          width: 52px;
          height: 52px;
        }
      }
      .i-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-size: 14px;
        color: #beecff;
        padding: 0 0px 2px;
        .val {
          color: #00cbff;
        }
      }
    }
  }
}
</style>
